import React from "react";
import { connect } from "react-redux";
// import { getAuditsRequest } from "./Redux/actions";
import { formatDateLocale } from "../../../lib/utils.es6";
import TableInc from "../../../shared-ui/TableInc";
import SkeletonWrapper from "../../NewProductList/components/SkeletonWrapper/SkeletonWrapper";
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import { PRIMARY_THEME_COLOR_SHADE_1 } from "../../../lib/constants";
import * as actions from "../../Users/actions.es6"
import Grid from "@material-ui/core/Grid";
import { DatePicker } from '@material-ui/pickers';
import ButtonInc from "../../../shared-ui/ButtonInc";
import {Select, InputLabel} from "@mui/material";
import MenuItem from '@mui/material/MenuItem';

class UserActivityAudit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: null,
      toDate: null,
      size: this.props.size || 10,
    };
  }

  componentDidUpdate(prevProps) {
    const prevUser = prevProps.userData.userToViewAuthActivities;
    const currentUser = this.props.userData.userToViewAuthActivities;
    if (currentUser && (!prevUser || prevUser.id !== currentUser.id)) {
      this.getAudits({ fromDate: this.state.fromDate, toDate: this.state.toDate, size: this.state.size });
    }
  }

  getAudits = (pagingData) => {
    const payload = {
      userId: this.props.userData.userToViewAuthActivities ? this.props.userData.userToViewAuthActivities.id : "",
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      size: pagingData.size || this.state.size,
    };
    this.props.dispatch(actions.getUserAuthActivitiesRequest(payload));
  };



  render() {
    const { userData } = this.props;
    const audits = { events: userData.userAuthActivities, size: this.state.size, page: this.state.page, count: 0 } || {
      events: [],
      size: this.state.size,
      page: this.state.page,
      count: 0,
    };
    const events = audits.events;

    if (userData.userAuthActivitiesError) {
      return <div>
        <p>error: {userData.userAuthActivitiesError ? userData.userAuthActivitiesError.message : ""}</p>
      </div> 
    }

    return (

      	<Dialog
				open={this.props.openViewAuditDialog} fullWidth
				maxWidth='lg'
				onClose={() => {
					this.props.dispatch(actions.closeUserAuthActivitiesDialog());
					this.props.closeViewAuditDialog();
				}}
				fullScreen
			>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar style={{ background: PRIMARY_THEME_COLOR_SHADE_1 }}>
						<IconButton
							edge="start"
							color="inherit"
							onClick={() => {
								this.props.dispatch(actions.closeUserAuthActivitiesDialog());
								this.props.closeViewAuditDialog();
							}}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
					View User Audit Trail
						</Typography>
					</Toolbar>
				</AppBar>

				<DialogContent>
					<div style={{ marginTop: "2%", width: '100%' }}>
            <Grid container spacing={2} style={{ marginBottom: '16px', display: 'flex', gap: '10px', alignItems: 'end' }}>  
                <p style={{ fontWeight: 'bold' }}>Filter by:</p>
            <div style={{
              backgroundColor:"#fff",
              padding: '6px',
              display: 'flex',
              gap: '16px',
              justifyContent: 'start',
              alignItems: 'end'
            }}>
              
             <DatePicker label="From Date" id='fromDate'  
               value={this.state.fromDate} 
              onChange={(newValue) => this.setState({ fromDate: newValue })} 
              name='fromDate' />
              <DatePicker label="To Date" id='toDate' 
              value={this.state.toDate} 
              onChange={(newValue) => this.setState({ toDate: newValue })} 
              name='toDate' />
              <Grid style={{ minWidth: 120, display: 'flex', flexDirection: 'row', alignItems: 'end', justifyContent: 'center', gap: '8px' }}>
                <InputLabel id="size-label">Size</InputLabel>
                <Select
                label="Size"
                value={this.state.size}
                onChange={(event) => this.setState({ size: event.target.value })}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
              </Grid>
              
               <ButtonInc
                variant="contained" 
                onClick={() => this.getAudits({ fromDate: this.state.fromDate, toDate: this.state.toDate, size: this.state.size })}
              >
                Filter
              </ButtonInc>
            </div>
            </Grid>
            {userData.userAuthActivitiesLoader ? (
              <SkeletonWrapper loading={true} />
            ) :(
        <TableInc
        columns={[
          { title: "Event Type", field: "event_type" },
          { title: "Description", field: "description" },
          { title: "Full Name", field: "full_name" },
          { title: "IP Address", field: "ip_address" },
          {
            title: "Created At",
            field: "created_at",
            render: (rowData) => formatDateLocale(rowData.created_at),
          },
        ]}
        data={(query) =>
          new Promise((resolve, reject) => {
            resolve({
              data: [...events],
              page: this.state.page,
              totalCount: audits.count,
            });
          })
        }
        options={{
          showTitle: false,
          pageSizeOptions: [1, 5, 10, 20, 50, 100],
          pageSize: this.state.size,
          paging: false
        }}
        onChangeRowsPerPage={(pageSize) => {
          this.setState({ size: pageSize });
          this.getAudits({ 
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            size: pageSize 
          });
        }}
        onChangePage={(page) => {
          this.setState({ page: page });
          this.getAudits({ page: page + 1 });
        }}
      />
  )}
					</div>

				</DialogContent>
			</Dialog>
   
    );
  }
}

export default connect((state) => ({
  userData: state.userAdmin,
  globalData: state.global,
  partnersData: state.partners,
}))(UserActivityAudit);
